<template>
  <view class="global-component">
    <ModuleTipMatchGlobalNotice />
    <UiTipMatchAuthLogin
      v-bind="UiTipMatchAuthLogin"
      ref="UiTipMatchAuthLogin"
    />
    <ModuleMatchPersonInfo
      v-bind="ModuleMatchPersonInfo"
      ref="ModuleMatchPersonInfo"
    />
    <MatchCommDialog
      v-bind="MatchCommDialog"
      ref="MatchCommDialog"
    />
    <UiTipMatchSharePrompt
      ref="UiTipMatchSharePrompt"
      v-bind="UiTipMatchSharePrompt"
    />
    <UiOfficialAccountDialog
      ref="UiOfficialAccountDialog"
      v-bind="UiOfficialAccountDialog"
    />
    <ModulePollGetMyAward
      ref="ModulePollGetMyAward"
    />
    <ProtocolDialog v-if="!isHor" />

    <PressDialog
      ref="pressDialog"
      if="press-dialog"
    />
  </view>
</template>
<script>
import ModuleTipMatchGlobalNotice from 'src/local-component/module/tip-match/tip-match-global-notice/index.vue';
import UiTipMatchAuthLogin from 'src/local-component/ui/tip-match/tip-match-auth-login/index.vue';
import ModuleMatchPersonInfo from 'src/local-component/module/tip-match/tip-match-person-info/person-info.vue';
import MatchCommDialog from '@tencent/press-ui/press-dialog/press-dialog.vue';
import UiTipMatchSharePrompt from 'src/local-component/ui/tip-match/tip-match-share-prompt/index';
import UiOfficialAccountDialog from 'src/local-component/ui/tip-match/tip-match-qr-code-popup/index.vue';
import ModulePollGetMyAward from 'src/local-component/module/tip-match/poll-get-my-award';
import ProtocolDialog from 'src/local-component/module/tip-match/tip-match-protocol-dialog/index';
import PressDialog from '@tencent/press-ui/press-dialog/press-dialog.vue';

// import ModuleTipMatchGlobalNotice from 'src/local-component/module/tip-match/tip-match-global-notice/index.vue';
// import UiTipMatchAuthLogin from 'src/local-component/ui/tip-match/tip-match-auth-login/index.vue';
// import ModuleMatchPersonInfo from 'src/local-component/module/tip-match/tip-match-person-info/person-info.vue';
// import MatchCommDialog from '@tencent/press-ui/press-dialog/press-dialog.vue';
// import UiTipMatchSharePrompt from 'src/local-component/ui/tip-match/tip-match-share-prompt/index';
// import UiOfficialAccountDialog from 'src/local-component/ui/tip-match/tip-match-qr-code-popup/index.vue';
// import ModulePollGetMyAward from 'src/local-component/module/tip-match/poll-get-my-award';
// import ModuleMatchPay from 'src/local-component/module/tip-match/tip-match-pay';
// import ProtocolDialog from 'src/local-component/module/tip-match/tip-match-protocol-dialog/index';
export default {
  components: {
    ModuleTipMatchGlobalNotice,
    UiTipMatchAuthLogin,
    ModuleMatchPersonInfo,
    MatchCommDialog,
    UiTipMatchSharePrompt,
    UiOfficialAccountDialog,
    ModulePollGetMyAward,
    ProtocolDialog,
    PressDialog,
  },
  data() {
    return {
      UiTipMatchAuthLogin: {},
      ModuleMatchPersonInfo: {},
      MatchCommDialog: {},
      UiTipMatchSharePrompt: {},
      UiOfficialAccountDialog: {},
      ModuleMatchPay: {},
    };
  },
  methods: {
    setComponent(ref, props = {}) {
      const component = this.$refs[ref];
      if (component) {
        // 修复web [Vue warn]: Avoid mutating a prop directly
        // Object.assign(component, props);
        if (this[ref]) this[ref] = props;
      }
      return component;
    },
  },
};
</script>
<style lang="scss" scoped src="./index.scss">
</style>
